import React from 'react';
import { createPortal } from 'react-dom';
import ClassChangeRequestModal from '../../components2/ClassChangeRequest';

// The onboarding class-change form (POST /class-change/class-change-request),
// for pages outside onboarding. It replaced a mailto: link that opened an empty
// tab for teachers without a desktop mail app.
//
// Portalled to <body>: the Class Insights popups keep a transform after their
// open animation, which would pin the form's position: fixed overlay to the
// popup instead of the viewport.
export function ClassChangeRequestDialog({ open, onClose }) {
  if (!open) return null;
  return createPortal(
    <ClassChangeRequestModal onClose={onClose} />,
    document.body
  );
}
